var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150 300C232.843 300 300 232.843 300 150C300 131.224 296.55 113.253 290.25 96.6873C290.745 100.722 291 104.831 291 109C291 164.228 246.228 209 191 209C135.772 209 91 164.228 91 109C91 53.7715 135.772 9 191 9C195.169 9 199.278 9.25508 203.313 9.75049C186.747 3.44993 168.776 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150 300C232.843 300 300 232.843 300 150C300 131.224 296.55 113.253 290.25 96.6873C290.745 100.722 291 104.831 291 109C291 164.228 246.228 209 191 209C135.772 209 91 164.228 91 109C91 53.7715 135.772 9 191 9C195.169 9 199.278 9.25508 203.313 9.75049C186.747 3.44993 168.776 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
    fill: "url(#paint0_linear_37_3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203 171C244.421 171 278 137.421 278 96C278 54.5786 244.421 21 203 21C161.579 21 128 54.5786 128 96C128 102.281 128.772 108.381 130.226 114.211C132.637 88.8435 154.001 69 180 69C207.614 69 230 91.3858 230 119C230 144.999 210.156 166.363 184.789 168.774C190.619 170.228 196.719 171 203 171Z",
    fill: "#F1F1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203 171C244.421 171 278 137.421 278 96C278 54.5786 244.421 21 203 21C161.579 21 128 54.5786 128 96C128 102.281 128.772 108.381 130.226 114.211C132.637 88.8435 154.001 69 180 69C207.614 69 230 91.3858 230 119C230 144.999 210.156 166.363 184.789 168.774C190.619 170.228 196.719 171 203 171Z",
    fill: "url(#paint1_linear_37_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_3",
    x1: 295.231,
    y1: -6.91452,
    x2: -18.2085,
    y2: 241.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114583,
    stopColor: "#1AC6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6451D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_37_3",
    x1: 275.616,
    y1: 17.5427,
    x2: 118.896,
    y2: 141.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114583,
    stopColor: "#1AC6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6451D6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4341ca124b02ff2e44022b45c1fc8a2c.svg";
export { ForwardRef as ReactComponent };